export const GadgetsProductVariantAttribute = (
	attribute: IGadgetsProductVariantAttribute,
): IGadgetsProductVariantAttributeModel => {
	const { name, value } = attribute

	return {
		name,
		value,
	}
}

export const GadgetsProductVariant = (variant: IGadgetsProductVariant): IGadgetsProductVariantModel => {
	const { gadget_id, is_active, image, attributes, has_own_physical_parameters, updated_at, created_at, ...rest } =
		variant

	return {
		...rest,
		gadgetId: gadget_id,
		isActive: is_active,
		image: image ? Media(image) : null,
		attributes: attributes.map(GadgetsProductVariantAttribute),
		hasOwnPhysicalParameters: has_own_physical_parameters,
		updatedAt: updated_at ? new Date(updated_at) : null,
		createdAt: created_at ? new Date(created_at) : null,
	}
}

const GadgetsProductVariantOptionValue = (
	model: IGadgetsProductVariantOptionValue,
): IGadgetsProductVariantOptionValueModel => {
	const { ...rest } = model

	return {
		...rest,
	}
}

export const GadgetsProductVariantOption = (model: IGadgetsProductVariantOption): IGadgetsProductVariantOptionModel => {
	const { values, ...rest } = model

	return {
		...rest,
		values: values.map(GadgetsProductVariantOptionValue),
	}
}

/**
 * Form
 */

/**
 * Here its important to set position after model is created
 */
const GadgetsProductVariantAttributeToForm = (
	attribute: IGadgetsProductVariantAttributeModel,
): IGadgetsProductVariantAttributeForm => {
	const { name, value } = attribute

	return {
		name,
		value,
		position: 0,
	}
}

export const GadgetsProductVariantToForm = (
	model: IGadgetsProductVariantModel,
	variantsOptions: IGadgetsProductVariantOptionForm[],
): IGadgetsProductVariantForm => {
	const {
		id,
		ean,
		order,
		image,
		isActive,
		attributes,
		hasOwnPhysicalParameters,
		width,
		height,
		length,
		weight,
		volume,
		material,
	} = model

	const options = attributes.map(attribute => {
		const attributeModel = GadgetsProductVariantAttributeToForm(attribute)

		return {
			...attributeModel,
			position: variantsOptions.find(option => option.title === attribute.name)?.position ?? 0,
		}
	})

	return {
		id,
		ean,
		order,
		isActive,
		hasOwnPhysicalParameters,
		width,
		height,
		length,
		weight,
		volume,
		material,
		options,
		media: image,
	}
}

export const GadgetsProductVariantsOptionsToForm = (
	model: IGadgetsProductVariantOptionModel,
): IGadgetsProductVariantOptionForm => {
	const { position, key, values } = model

	return {
		position,
		title: key,
		values: values.sort((a, b) => a.position - b.position).map(value => value.value),
	}
}

/**
 * Payloads
 */
const GadgetsProductVariantOptionPayload = (
	option: IGadgetsProductVariantOptionForm,
): IGadgetsProductVariantOptionPayload | undefined => {
	const { title, values } = option

	if (!title || !values.length) return undefined

	return {
		values,
		key: title,
	}
}

const GadgetsProductVariantAttributePayload = (
	attribute: IGadgetsProductVariantAttributeForm,
): IGadgetsProductVariantAttributePayload => {
	const { name, value } = attribute

	return {
		value,
		name: name!, //validation checked in form
	}
}

const GadgetsProductVariantItemPayload = (variant: IGadgetsProductVariantForm): IGadgetsProductVariantItemPayload => {
	const {
		id,
		order,
		ean,
		options,
		isActive,
		hasOwnPhysicalParameters,
		width,
		height,
		length,
		weight,
		volume,
		material,
	} = variant

	return {
		id,
		ean,
		order,
		width,
		height,
		length,
		weight,
		volume,
		material,
		is_active: isActive,
		has_own_physical_parameters: hasOwnPhysicalParameters,
		attributes: options.map(GadgetsProductVariantAttributePayload),
	}
}

const GadgetsProductVariantCommonPayload = (
	variants: IGadgetsProductVariantForm[],
	variantsInitial: IGadgetsProductVariantForm[],
	options: IGadgetsProductVariantOptionForm[],
	isGadgetActive: boolean,
): IGadgetsProductVariantCommonPayload => {
	const deletedVariants = variantsInitial
		.filter(
			initialVariant =>
				initialVariant.id !== undefined &&
				!variants.some(currentVariant => currentVariant.id === initialVariant.id),
		)
		.map(variant => variant.id)
		.filter(id => id !== undefined)

	const variantsPayload = variants.map(GadgetsProductVariantItemPayload)

	return {
		options: options.map(GadgetsProductVariantOptionPayload).filter(option => option !== undefined),
		variants: variantsPayload,
		delete_variants: deletedVariants,
		is_gadget_active: isGadgetActive,
	}
}

export const GadgetsProductVariantCreateToPayload = (
	variants: IGadgetsProductVariantForm[],
	options: IGadgetsProductVariantOptionForm[],
	isGadgetActive: boolean,
): IGadgetsProductVariantCreatePayload => {
	const shared = GadgetsProductVariantCommonPayload(variants, [], options, isGadgetActive)

	return {
		...shared,
	}
}

export const GadgetsProductVariantUpdateToPayload = (
	variants: IGadgetsProductVariantForm[],
	variantsInitial: IGadgetsProductVariantForm[],
	options: IGadgetsProductVariantOptionForm[],
	isGadgetActive: boolean,
): IGadgetsProductVariantUpdatePayload => {
	const shared = GadgetsProductVariantCommonPayload(variants, variantsInitial, options, isGadgetActive)

	return {
		...shared,
	}
}
